var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.prevRoute && _vm.prevRoute.name
        ? _c(
            "nav",
            [
              _c(
                "router-link",
                { attrs: { to: { name: _vm.prevRouteName } } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", icon: "el-icon-arrow-left" } },
                    [
                      _vm._v(
                        "Back to " + _vm._s(_vm.routeLabel(_vm.prevRouteName))
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("el-container", { staticClass: "container" }, [
        _c("main", [_c("register")], 1),
        _vm._v(" "),
        _c(
          "aside",
          [_c("login", { attrs: { accountExists: _vm.accountExists } })],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }